import "../../style/mobile/home/M_AmazingOffer.scss";
// import Slider from 'react-slick';
import img1 from "../../../assets/store/amazing-suggest/ella-olsson-KPDbRyFOTnE-unsplash.jpg";
import img2 from "../../../assets/store/amazing-suggest/antoine-dautry-_zsL306fDck-unsplash.jpg";
import img3 from "../../../assets/store/amazing-suggest/ahmed-almakhzanji-kshkB1i5_5o-unsplash.jpg";
import icon1 from "../../../assets/mobile/home/vuesax-linear-calendar.svg";
import icon2 from "../../../assets/mobile/home/vuesax-linear-profile-2user.svg";
import icon3 from "../../../assets/mobile/home/vuesax-linear-teacher.svg";
import icon4 from "../../../assets/mobile/home/discount-shape.svg";
import bg from "../../../assets/mobile/home/bg.png";
import { useState } from "react";
import { useEffect } from "react";

let ao_data = [
  {
    id: 1,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 2,
    img: img2,
    title: "آزمون مدارهای مخابراتی پیشرفته",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 3,
    img: img1,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 4,
    img: img3,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
  {
    id: 5,
    img: img3,
    title: "آزمون آشپزی شرق آسیا",
    // price:458.200,
    price: 450200,
    discounted_price: 405000,
    discount: "10%",
    date: "28 آبان 1400",
    level: "پایه 1 الی 12",
    type: "گروهی",
    user_num: 100,
  },
];

const M_AmazingOffer = () => {
  return (
    <div className="M_AmazingOffer">
      <div className="M_AmazingOffer-bg">
        <img src={bg} alt="bg-img" />
      </div>
      <div className="M_AmazingOffer-header-box">
        <div className="M_AmazingOffer-header-box-title">
          <img
            src={icon4}
            alt="icon4"
            className="M_AmazingOffer-header-box-title-icon"
          />
          <div className="M_AmazingOffer-header-box-title-text">
            پیشنهاد شگفت‌انگیز
          </div>
        </div>
        <AmazingSuggestTimer />
      </div>
      <div className="M_AmazingOffer-body">
        {ao_data.map((item) => (
          <div className="M_AmazingOffer-body-item" key={item.id}>
            <div className="M_AmazingOffer-body-item-img-container">
              <img src={item.img} alt="item-img" />
              <div className="M_AmazingOffer-body-item-img-container-cover"></div>
            </div>
            <div className="M_AmazingOffer-body-item-title">{item.title}</div>
            <div className="M_AmazingOffer-body-item-price-box">
              <div
                style={
                  item.discount
                    ? { textDecoration: "line-through", color: "#A7A5A5" }
                    : null
                }
                className="M_AmazingOffer-body-item-price-box-main-price"
              >
                {item.price}
                <span>تومان</span>
              </div>
              <div className="M_AmazingOffer-body-item-price-box-discounted-price">
                {item.discounted_price}
                <span>تومان</span>
              </div>
              <div className="M_AmazingOffer-body-item-price-box-discount">
                {item.discount}
              </div>
            </div>
            <div className="M_AmazingOffer-body-item-info">
              <div className="M_AmazingOffer-body-item-info-date">
                <img
                  src={icon1}
                  alt="date-icon1"
                  className="M_AmazingOffer-body-item-info-date-icon"
                />
                <div className="M_AmazingOffer-body-item-info-date-text">
                  {item.date}
                </div>
              </div>
              <div className="M_AmazingOffer-body-item-info-level">
                <img
                  src={icon2}
                  alt="date-icon1"
                  className="M_AmazingOffer-body-item-info-level-icon"
                />
                <div className="M_AmazingOffer-body-item-info-level-text">
                  {item.level}
                </div>
              </div>
              <div className="M_AmazingOffer-body-item-info-type">
                <img
                  src={icon3}
                  alt="date-icon1"
                  className="M_AmazingOffer-body-item-info-type-icon"
                />
                <div className="M_AmazingOffer-body-item-info-type-text">
                  {item.type}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default M_AmazingOffer;

const AmazingSuggestTimer = () => {
  // console.log("AST renser.............");

  const event_end = new Date(2021, 9, 13, 23, 0, 0, 0);
  const now = new Date();
  let time_diff = (event_end - now) / 1000;
  const H = Math.floor(time_diff / 3600);
  const MIN = Math.floor((time_diff - H * 3600) / 60);
  const SEC = Math.floor(time_diff - (H * 3600 + MIN * 60));
  const [h, set_h] = useState(H);
  const [min, set_min] = useState(MIN);
  const [sec, set_sec] = useState(SEC);

  useEffect(() => {
    // console.log(sec);
    if (sec >= 0 && time_diff > 0) {
      setTimeout(() => {
        // console.log("okdkdokodkd");
        set_sec(sec - 1);
        if (sec === 0) {
          set_sec(59);
          set_min(min - 1);
        }
        if (min === 0) {
          set_h(h - 1);
          set_min(59);
        }
      }, 1000);
    }
  });

  return (
    <div className="mh-amazing_suggest_timer">
      <div className="as-t-text">تا پایان شگفت انگیز</div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{sec}</div>
        <div className="as-t-num-box-text">ثانیه</div>
      </div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{min}</div>
        <div className="as-t-num-box-text">دقیقه</div>
      </div>
      <div className="as-t-num-box">
        <div className="as-t-num-box-num">{h}</div>
        <div className="as-t-num-box-text">ساعت</div>
      </div>
    </div>
  );
};
